export default __webpack_public_path__ + "fonts/Roboto-Medium.ttf";